import type { PromoRendererProps } from '@ps-int/promozavr/app/PromoRenderer';

import { theme as telemostDarkTheme } from '../../../themes/orb-migrate-dark';
import { theme as telemostLightTheme } from '../../../themes/orb-migrate-light';
import { sendPromozavrMetric } from './metrics';
import { getPromozavrPlatform, getPromozavrProjectByQueue } from './queue-project';
import { type PromozavrQueueKind, type PromozavrQueueSelection } from './types';

export type PromozavrRuntimeRendererProps = PromoRendererProps & {
    isActive: boolean;
    deactivate: () => void;
};

type BuildPromozavrRendererPropsParams = {
    selection: PromozavrQueueSelection;
    queue: PromozavrQueueKind;
    isActive: boolean;
    deactivate: () => void;
    isDark: boolean;
    getNow: PromoRendererProps['getNow'];
    dsClient: PromoRendererProps['dsClient'];
    appLang: string;
    isTouch: boolean;
    urls: PromoRendererProps['urls'];
    hasSubscription: boolean;
};

export function buildPromozavrRendererProps({
    selection,
    queue,
    isActive,
    deactivate,
    isDark,
    getNow,
    dsClient,
    appLang,
    isTouch,
    urls,
    hasSubscription,
}: BuildPromozavrRendererPropsParams): PromozavrRuntimeRendererProps | undefined {
    if (!selection.selectedPromo || !selection.translations) {
        return undefined;
    }

    return {
        currentPromo: selection.selectedPromo,
        translations: selection.translations,
        imageStore: selection.images,
        sendMetric: sendPromozavrMetric,
        theme: isDark ? telemostDarkTheme : telemostLightTheme,
        darkTheme: telemostDarkTheme,
        lightTheme: telemostLightTheme,
        isDark,
        getNow,
        dsClient,
        lang: appLang as PromoRendererProps['lang'],
        project: getPromozavrProjectByQueue(queue, isTouch) as PromoRendererProps['project'],
        platform: getPromozavrPlatform(isTouch),
        isTouch,
        urls,
        hasSubscription,
        isActive,
        deactivate,
        onClose: deactivate,
    };
}
